import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-welcome",
  templateUrl: "./welcome.component.html",
  styleUrls: ["./welcome.component.sass"],
})
export class WelcomeComponent implements OnInit {
  smsLink: string;

  constructor() {}

  ngOnInit(): void {
    const phoneNumber = "12084714483";
    const message = `#bookclub
#productinfo
#buildingtips
#reminders
#testimonials
#motivation`;
    this.smsLink = `sms:${phoneNumber}?body=${encodeURIComponent(message)}`;
  }
}
